import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { Section, Columns, Column, Title } from 'bulma-react';
import { IconButton } from './common';

import './TopController.css';

export class TopController extends Component {
  state = { showUpdates: true };
  toggleActionButtons = () => {
    const { showButtons } = this.state;
    this.setState({ showButtons: !showButtons });
  };
  toggleShowUpdates = () => {
    const { showUpdates } = this.state;
    this.props.stateCb({ showUpdates: !showUpdates });
    this.setState({ showUpdates: !showUpdates, showButtons: false });
  }
  download = () => {
    console.log('download!');
    this.props.onClickEvent('download');
    this.setState({ showButtons: false });
  }
  render = () => {
    const { showUpdates, showButtons } = this.state;
    return (
    <div>
      <div style={{
        height: '100%',
        position: 'absolute',
        zIndex: '100',
        top: 0,
        bottom: 0,
        left: 0,
        width: '100%',
        display: !showButtons && 'none',
      }} onClick={() => this.setState({ showButtons: false })}>
      </div>
      <Columns is-mobile style={{
        marginBottom: '-1rem',
      }}>
        <Column column is-1 style={{ paddingLeft: 0 }}>
          <div className="menu left" style={{
            zIndex: '110',
            position: 'relative',
          }}>
            <IconButton name="snapmongo" onClick={this.toggleActionButtons}/>
            <IconButton className={classnames('actionButton', { hidden: !showButtons })}
              name={showUpdates ? 'eye-slash' : 'eye'}
              onClick={this.toggleShowUpdates}
              style={{
                left: showButtons && '60px',
              }}/>
            <IconButton className={classnames('actionButton', { hidden: !showButtons })}
              name="download"
              onClick={this.download}
              style={{
                left: showButtons && '120px',
              }}/>
          </div>
        </Column>
        <Column is-10>
          &nbsp;
        </Column>
        <Column is-1 style={{ paddingRight: 0 }}>
          <div className="search right" style={{ textAlign: 'right' }}>
            <Link to="/about">
              <IconButton name="search" />
            </Link>
          </div>
        </Column>
      </Columns>
    </div>
  )};
}



// WEBPACK FOOTER //
// ./src/components/TopController.js